<template>
    <div v-if="dataLoaded && ticker" :class="{ 'container-max': width, 'load' : !dataLoaded }">
        <vue-glide :perView="1" :autoplay="5000">
            <vue-glide-slide>
                <div class="main-rate">
                    <span class="txt" v-if="dataLoaded">
                        <template v-if="parseFloat(reviews.rating.replace(',','.')) < 1.5">{{ $translate("reviewWidget::Template.rate1") }}</template>
                        <template v-else-if="parseFloat(reviews.rating.replace(',','.')) < 2.5">{{ $translate("reviewWidget::Template.rate2") }}</template>
                        <template v-else-if="parseFloat(reviews.rating.replace(',','.')) < 3.5">{{ $translate("reviewWidget::Template.rate3") }}</template>
                        <template v-else-if="parseFloat(reviews.rating.replace(',','.')) < 4.5">{{ $translate("reviewWidget::Template.rate4") }}</template>
                        <template v-else>{{ $translate("reviewWidget::Template.rate5") }}</template>
                    </span>
                    <span class="txt" v-else>
                        ...
                    </span>
                    <span class="rating" :class="{ 'x' : !hideText }">
                        <span class="blank">
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                        </span>
                        <span class="rate" style="width:0%" :style="'width:' + parseFloat(reviews.rating.replace(',','.')) * 20 + '%'" v-if="dataLoaded">
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                        </span>
                        <span class="rate" style="width:0%" v-else>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                        </span>
                    </span>

                    <span class="br">
                        <span>
                            <span class="rate-decimal" v-if="dataLoaded">{{ reviews.rating }}</span>
                            <span class="rate-decimal" v-else>...</span>
                            <span class="txt txt1">{{ $translate("reviewWidget::Template.summary1") }}</span>
                            <span class="rate-count" v-if="dataLoaded">{{ reviews.userScore }}</span>
                            <span class="rate-count" v-else>...</span>
                            <span class="txt txt2">{{ $translate("reviewWidget::Template.summary2") }}</span>
                        </span>
                    </span>
                </div>
            </vue-glide-slide>
            <vue-glide-slide v-for="(item, index) in ticker" :key="index">
                <div v-html="item.text"></div>
            </vue-glide-slide>
        </vue-glide>
    </div>
    <div v-else :class="{ 'container-max': width, 'load' : !dataLoaded }">
        <span class="txt" v-if="dataLoaded">
            <template v-if="parseFloat(reviews.rating.replace(',','.')) < 1.5">{{ $translate("reviewWidget::Template.rate1") }}</template>
            <template v-else-if="parseFloat(reviews.rating.replace(',','.')) < 2.5">{{ $translate("reviewWidget::Template.rate2") }}</template>
            <template v-else-if="parseFloat(reviews.rating.replace(',','.')) < 3.5">{{ $translate("reviewWidget::Template.rate3") }}</template>
            <template v-else-if="parseFloat(reviews.rating.replace(',','.')) < 4.5">{{ $translate("reviewWidget::Template.rate4") }}</template>
            <template v-else>{{ $translate("reviewWidget::Template.rate5") }}</template>
        </span>
        <span class="txt" v-else>
            ...
        </span>
        <span class="rating" :class="{ 'x' : !hideText }">
            <span class="blank">
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
            </span>
            <span class="rate" style="width:0%" :style="'width:' + parseFloat(reviews.rating.replace(',','.')) * 20 + '%'" v-if="dataLoaded">
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
            </span>
            <span class="rate" style="width:0%" v-else>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
            </span>
        </span>

        <span class="br">
            <span>
                <span class="rate-decimal" v-if="dataLoaded">{{ reviews.rating }}</span>
                <span class="rate-decimal" v-else>...</span>
                <span class="txt txt1">{{ $translate("reviewWidget::Template.summary1") }}</span>
                <span class="rate-count" v-if="dataLoaded">{{ reviews.userScore }}</span>
                <span class="rate-count" v-else>...</span>
                <span class="txt txt2">{{ $translate("reviewWidget::Template.summary2") }}</span>
            </span>
        </span>
    </div>
</template>

<script>
    import { Glide, GlideSlide } from 'vue-glide-js';
    export default {
        components: {
            [Glide.name]: Glide,
            [GlideSlide.name]: GlideSlide
        },
        data: function() {
            return {
                reviews: [],
                dataLoaded: false
            }
        },
        props: {
            width: false,
            ticker: 0,
            hideText: false
        },
        mounted() {
            var self = this,
            reviews = [];

            $.getJSON('/rest/reviewWidget/get/summary').done(function( data ) {
                self.reviews = data;
                self.dataLoaded = true;
            })
        }
    }
</script>
